export default __webpack_public_path__ + "static/media/pools_and_farms.5981d825.svg";